import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Grid } from "../core/components/grid.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { Config } from "../core/config/config.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { TextBox } from "../core/components/textBox.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { FieldInstance } from "../core/components/field.js";
import { Helper } from "../core/util/helper.js";
import React from "react";
import ReactDOM from "react-dom";

interface Contact {
    Typ: string;
    Pos: number;
    AdrNr: string;
}
export default class ProjectContacts extends React.Component<{ entity: { ProjectStatus, RecordRight }, context }, { gridData: Contact[] }>{
    //private _gridData = [];
    private gridOptions = {};
    private dataUrl: string;
    private enabled: boolean;
    private projNr: string;
    constructor(props) {
        super(props);
        this.projNr = props.entity.Projnr;
        this.enabled = true;
        this.dataUrl = "ProjectContactPersons/GetProjectGridData?id=" + this.projNr;
        this.gridOptions = this.props.context.projectContactsGrid;

        this.state = {
            gridData: []
        }
    }

    private async getGridData() {
        const result = await HTTPService.get(this.dataUrl);
        this.setState({ gridData: result.Data.GridData });
    }

    private remove = async (dataItem) => {
        const result = await HTTPService.get('ProjectContactPersons/RemoveFromProject?id=' + dataItem.Pos + '&projnr=' + encodeURIComponent(this.projNr));
        await this.getGridData();
    }


    private handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        switch (type) {
            case ToolBarStandardButtonType.DELETE:
                this.remove(dataItem);
                break;
            case ToolBarStandardButtonType.EDIT:
                this.edit(dataItem)
                break;
        }
    }

    private edit = (dataItem: Contact) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);

        const onClose = () => {
            root.unmount(targetElement[0]);
            targetElement[0].remove();
        }

        const save = async (typ) => {
            const gridData = this.state.gridData;
            const index = gridData.findIndex(d => d.Pos == dataItem.Pos)
            gridData[index].Typ = typ;

            const { Code, Message } = await HTTPService.post<JsonResultClass>("ProjectContactPersons/Update", {
                model: gridData[index],
                projNr: encodeURI(this.projNr)
            });
            if (Code == 0) {
                NotificationHelper.showSuccessMessage(Message);
                this.setState({ gridData: gridData })
            } else {
                NotificationHelper.showErrorMessage(Message)
            }



        }

        root.render(<ContactDialog dataItem={dataItem} onClose={onClose} onOk={save} />);
    }

    private handleClickCustomButton = (id: string, dataItem: any, dataItems: Array<any>) => {
        if (id === "add") {
            const sheet = General.Sheet.Manager.createSheetWithUrl(`DynamicSearch/Window/Contact?multi=true&displayPattern=[[ansprechpartner]]`, null, { disableTabTitle: true });
            sheet.bind(SheetEventType.ItemsSelected, async (ev) => {
                let positions = ev.data.map(x => x.pos);
                this.addContacts(positions);
            });
        }
    }

    private addContacts = async (positions) => {
        let result = await HTTPService.post<JsonResultClass>("ProjectContactPersons/AddContacts",
            {
                projNr: encodeURI(this.projNr),
                positions: positions
            });
        if (result.Code == 0) {
            await this.getGridData();
            NotificationHelper.showSuccessMessage(result.Message);
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "projectStatusChanged") {
                this.enabled = cus.value;
                this.setState({});
            }
        });
        $(window).on("contactPersonAdded", () => {
            this.getGridData();
        });
    }

    private checkEditability = () => {
        if (this.props.context.contextType === "project") {
            this.enabled = this.props.entity.ProjectStatus.Editing;
            this.setState({});
        }
    }

    componentDidMount() {
        this.setEvents();
        this.checkEditability();
        this.getGridData();
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.props.entity.RecordRight.CanWrite && this.enabled },
            { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this.props.entity.RecordRight.CanWrite && this.enabled },
        ];

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            id: "add", caption: Config.translations.add, enabled: this.props.entity.RecordRight.CanWrite && this.enabled, iconClass: "k-i-plus", autoEnabledOnRecordSelected: false
        });

        const content = <Grid data={this.state.gridData} options={this.gridOptions} id="projectContacts"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton}
            customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton} copyCellValue={true} />

        return <>{content}</>;
    }
}

class ContactDialog extends React.Component<{ dataItem, onClose: () => void, onOk: (typ: string) => void }, { typ: string }>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk(this.state.typ)
                },
                primary: true
            }
        ],
        afterClose: this.props.onClose,
        width: 500,
        open: true
    };


    constructor(props) {
        super(props)
        this.state = {
            typ: this.props.dataItem.Typ
        }
    }

    private renderTextbox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.typ;
        props.onChange = (_, value) => {
            this.setState({ typ: value })
        }
        return <FieldInstance label={Helper.getTranslation("Field.Ansprechpartner.typ")}><TextBox {...props} /></FieldInstance>
    }

    render() {
        return <Dialog {...this.dialogProps} >{this.renderTextbox()}</Dialog>
    }
}